var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-wrap"},[_c('svg-icon',{attrs:{"icon":_vm.isPlay ? 'audio' : 'audio-pause'},nativeOn:{"click":function($event){return _vm.playAudio.apply(null, arguments)}}}),_c('audio',{ref:"audio",staticStyle:{"display":"none"},attrs:{"src":_vm.audioUrl},on:{"ended":_vm.audioEnded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }